import { ReactNode, useState } from 'react';
import Slick from 'react-slick';
import ArrowSq from '@alltrails/shared/icons/ArrowSq';
import IconButton from '@alltrails/shared/denali/components/IconButton';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import classNames from 'classnames';
import * as styles from './styles/styles.module.scss';

const ArrowFn =
  (key: any, arrowStyles: any) =>
  ({ className, onClick }: { className?: string; onClick?: () => void }) =>
    (
      <IconButton
        className={classNames(className, styles.button, styles[key], 'lazyload', arrowStyles[key])}
        icon={{ Component: ArrowSq, orientation: key === 'previous' ? 'left' : 'right' }}
        onClick={onClick}
        testId={key}
        title={key}
        variant="elevated"
      />
    );

type Props = {
  className?: string;
  trackClassName?: string;
  slickSettings?: any;
  useSlick?: boolean;
  arrowStyles?: {
    next: string;
    previous: string;
  };
  children: ReactNode[];
};

function River({ className, trackClassName, children, useSlick, slickSettings, arrowStyles }: Props) {
  const [dragging, setDragging] = useState(false);

  const PrevArrow = ArrowFn('previous', arrowStyles);
  const NextArrow = ArrowFn('next', arrowStyles);

  let river;
  if (useSlick) {
    const handleBeforeChange = () => {
      setDragging(true);
    };

    const handleAfterChange = () => {
      setDragging(false);
    };

    // Prevent propagation of click to inner elements when dragging slick carousel
    const onClickCapture = (e: any) => {
      if (dragging) {
        e.stopPropagation();
      }
    };

    const defaultSlickSettings = {
      accessibility: true,
      afterChange: handleAfterChange,
      beforeChange: handleBeforeChange,
      className: `${className} ${styles.slickRiver}`,
      dots: false,
      infinite: false,
      initialSlide: 0,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipeToSlide: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      variableWidth: true,
      lazyLoad: true,
      ...slickSettings
    };
    slickSettings = Object.assign(defaultSlickSettings, slickSettings);

    river = (
      <Slick {...slickSettings}>
        {children.map((child, i: number) => (
          <div className={styles.riverItem} key={`riverItem-${i}`} onClickCapture={onClickCapture}>
            {child}
          </div>
        ))}
      </Slick>
    );
  } else {
    river = (
      <div className={classNames(className, styles.river)}>
        <div className={classNames(trackClassName, styles.riverTrack)}>
          {children.map((child, i: number) => (
            <div className={styles.riverItem} key={`riverItem-${i}`}>
              {child}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return <div>{river}</div>;
}

River.defaultProps = {
  className: '',
  trackClassName: '',
  slickSettings: {},
  useSlick: false,
  arrowStyles: {
    next: '',
    previous: ''
  }
};

export default River;
